import { useEffect, useState } from 'react';
import { eventHistoryService, type RelanceCompletedEventDto } from '../services/eventHistoryService';

type LoadState = 'loading' | 'error' | 'ready';

// A customer realistically has a handful of sends; one generous page covers every real case.
const PAGE_SIZE = 100;

/** The reminders already sent to a customer, newest first. */
export function useSentRelanceEvents(customerId: string | undefined) {
    const [state, setState] = useState<LoadState>('loading');
    const [events, setEvents] = useState<RelanceCompletedEventDto[]>([]);

    useEffect(() => {
        if (!customerId) return;
        let cancelled = false;
        setState('loading');
        eventHistoryService
            .getHistory({ customerId, page: 1, pageSize: PAGE_SIZE, eventType: 'RELANCE_COMPLETED', orderDirection: 'desc' })
            .then(data => {
                if (cancelled) return;
                setEvents(data.items.filter((e): e is RelanceCompletedEventDto => e.type === 'RELANCE_COMPLETED'));
                setState('ready');
            })
            .catch(() => {
                if (!cancelled) setState('error');
            });
        return () => {
            cancelled = true;
        };
    }, [customerId]);

    return { state, events };
}
